import BaseService from '@core/class/BaseService';
import { IPagination } from '../../Product/interfaces';
class ImportServices extends BaseService {
  public fetchData = ({
    productName,
    page,
    fieldSearch,
    sort,
    fromDt,
    toDt
  }: IPagination) => {
    let data = [...Array(10)].map((item, index) => ({
      ...item,
      ...{
        productName: ['', 't-Shirt', 'Jean', 'Kaky', 'Hat'][
          Math.ceil(Math.random() * 3)
        ],
        status: [
          '',
          'Request to import',
          'Approved import request',
          'Import completed'
        ][Math.ceil(Math.random() * 3)],
        SSKU: 33012 + Number(index),
        centerName: ['', 'Old', 'New'][Math.ceil(Math.random() * 2)],
        UpdateDate:
          new Date().getTime() +
          [0, 1000, 10000, 3000][Math.ceil(Math.random() * 3)]
      }
    }));
    return { data: data };
  };

  public getListImport = ({
    page,
    productName,
    sort,
    fromDt,
    toDt,
    valueSearch,
    proName
  }: IPagination) => {
    let filter = productName ? `&filter.status=${productName}` : '';
    let filterStock = proName ? `&filter.${proName}=${valueSearch}` : '';
    let url =
      'api/v1/seller/imports' + `?page=${page}&limit=10` + filter + filterStock;

    url = sort
      ? (url += `&sortBy=updated_at:DESC`)
      : (url += '&sortBy=updated_at:ASC');
    url = fromDt ? (url += `&filter.from=${fromDt}`) : url;
    url = toDt ? (url += `&filter.to=${toDt}`) : url;

    return this.get(url);
  };

  public exportExcelAll = ({
    productName,
    sort,
    fromDt,
    toDt,
    valueSearch
  }: IPagination) => {
    let url = `api/v1/seller/imports/export-all`;
    url =
      (!!productName && !!valueSearch) || !!sort || !!fromDt || !!toDt
        ? url + '?'
        : url;
    url +=
      (!!productName ? `&filter.status=${productName}` : '') +
      (!!valueSearch ? `&filter.keyword=${valueSearch}` : '') +
      (!!fromDt ? `&filter.from=${fromDt}` : '') +
      (!!toDt ? `&filter.to=${toDt}` : '') +
      (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC`);
    let urlUse = url.replace('?&', '?');

    return this.get(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportExcelById = (body: Record<string, any>) => {
    return this.get('api/v1/seller/imports/export', body, {
      responseType: 'blob'
    });
  };

  public getListImportDetail = (importId: number | string) => {
    return this.get(`api/v1/seller/imports/detail/${importId}`);
  };

  public removeImport = (productId: number | string) => {
    return this.delete(`api/v1/seller/imports/delete/${productId}`);
  };


  public searchQuotation = (valueSearch: number | string) => {
    return this.get(
      `api/v1/seller/quotations/list-create-request?id=${
        !!valueSearch ? valueSearch : ''
      }`
    );
  };

  public upLoad = (body: Record<string, any>) => {
    return this.post('api/v1/seller/imports/upload', body);
  };

  public createCommentImport = (body: Record<string, any>) => {
    return this.post(`api/v1/seller/imports`, body);
  };
}

export default new ImportServices('/', true);
